import { Injectable, signal } from '@angular/core';
import { webDtos } from '@vectronic/openApi-customer';
import { Observable, of } from 'rxjs';

@Injectable()
export class MovebankMockService {
  movebankUsername$ = of('accountUsername');
  movebankDeviceIds$ = of([1, 2, 3]);
  esriUrl = signal<string>(undefined);
  movebankAccount$: Observable<webDtos.MovebankAccount> = of({
    movebankUsername: 'accountUsername',
    deviceList: [
      {
        idDevice: 11494,
        creationTimestamp: '2022-09-09T09:02:44.936650Z',
        highestUploadId: 0,
        forwardData: true,
        uploadedDataCount: 0,
      },
    ],
  });
}
